import WaveSurfer from "wavesurfer.js";
import RecordPlugin from "wavesurfer.js/dist/plugins/record";

/**
 * The ONE home of "what a live recording waveform looks like" — thin rounded bars that
 * scroll while the mic is open. Both the legacy recorder popover (which lets WaveSurfer
 * own the mic) and the Birdie composer's waveform (which paints a stream someone else
 * recorded) build their instance here, so the two never drift apart visually.
 */

function cssVar(name: string, el: HTMLElement = document.documentElement) {
  return getComputedStyle(el).getPropertyValue(name).trim();
}

export interface RecordingWaveSurfer {
  wavesurfer: WaveSurfer;
  record: ReturnType<typeof RecordPlugin.create>;
}

export function createRecordingWaveSurfer(
  container: HTMLElement,
  options: { height?: number } = {},
): RecordingWaveSurfer {
  const color = cssVar("--color-text-primary");
  const wavesurfer = WaveSurfer.create({
    container,
    height: options.height ?? 32,
    barGap: 1,
    waveColor: color,
    progressColor: color,
    cursorWidth: 0,
    barWidth: 2,
    barMinHeight: 2,
    barRadius: 9999,
  });
  const record = wavesurfer.registerPlugin(
    RecordPlugin.create({
      renderRecordedAudio: false,
      continuousWaveform: false,
      scrollingWaveform: true,
    }),
  );
  return { wavesurfer, record };
}
